<!-- Hero Section -->
<div class="healthcare-section-bg">
    <section class="healthcare-section container py-5">
        <div class="glass-panel-container">
            <div class="row align-items-center">
                <div class="col-lg-6">
                    <h1 class="healthcare-heading mb-3">
                        Future-Ready Fintech Software Development Solutions
                    </h1>
                    <!-- <p class="healthcare-subheading1 mb-4">
            Health Care Industries
          </p> -->
                    <p class="healthcare-subheading2 mb-4">
                        Transform your financial ecosystem with secure, scalable, and AI-powered fintech software.
                        Deploy production-ready FinTech software, significantly faster with our AI-accelerated
                        development approach.
                    </p>
                    <!-- <p class="healthcare-subheading3 mb-4">
            We optimize your healthcare workflows through our custom-built software solutions.
          </p> -->
                    <div class="mb-5 contact-btn">
                        <!-- <button class="btn case-study-btn me-3" (click)="goToCaseStudies()">
              Case Studies
            </button> -->
                        <button class="btn hire-btn hire" (click)="scheduleDemo()">
                            Book a Free Consultation
                        </button>
                    </div>
                </div>

                <div class="col-lg-6 text-center">
                    <video #heroVideo preload="auto" src="../../../../assets/industries/fintech/fintech-herovideo.webm"
                        class="img-fluid hero-image" autoplay loop muted playsinline disablePictureInPicture>
                    </video>
                </div>
            </div>
        </div>
    </section>
</div>
<!-- Software Solutions in Healthcare Section -->
<section class="solutions-section">
    <div class="container">
        <div class="section-header text-center mx-auto">
            <h2>Why Fintech Innovation Matters Today</h2>
        </div>
        <div class="row">
            <div class="col-lg-6">
                <div class="solutions-image-container">
                    <div class="solution-image-card image-one">
                        <div class="image-overlay"></div>
                        <img src="../../../../assets/industries/fintech/fintech-img1.png"
                            alt="Team collaborating on computer">
                    </div>
                    <div class="solution-image-card image-two">
                        <div class="image-overlay"></div>
                        <img src="../../../../assets/industries/fintech/fintech-img2.png"
                            alt="Two colleagues looking at a laptop">
                    </div>
                </div>
            </div>
            <div class="col-lg-6">
                <div class="solutions-content">
                    <p>
                        The financial services landscape is rapidly evolving, from rising compliance demands to growing
                        expectations for faster, secure, and seamless digital payments. Traditional processes often
                        limit speed, accuracy, and customer satisfaction. At Kalpita Technologies, we empower finance
                        companies with custom fintech app development, AI-powered fintech solutions, blockchain
                        integration, and intelligent automation, that modernize operations, strengthen transaction
                        security, and scale revenue-driven innovation.
                    </p>
                    <p><strong>Key Benefits of Fintech Software Solutions: </strong></p>
                    <div class="features-list">
                        <ul>
                            <li><img src="../../../assets/home/arrow-indicator.svg" alt="Indicator">Faster & secure
                                digital transactions</li>
                            <li><img src="../../../assets/home/arrow-indicator.svg" alt="Indicator">Operational
                                efficiency with automation reducing cycle times</li>
                            <li><img src="../../../assets/home/arrow-indicator.svg" alt="Indicator">Enhanced customer
                                experience with personalized financial services</li>
                            <li><img src="../../../assets/home/arrow-indicator.svg" alt="Indicator">Real-time data
                                visibility & fraud detection</li>
                            <li><img src="../../../assets/home/arrow-indicator.svg" alt="Indicator">Regulatory
                                compliance & audit transparency</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<!-- Our Solutions & Impact Section -->
<section class="impact-section" #impactSection>
    <div class="container">
        <div class="text-center">
            <h2 class="impact-heading">Kalpita's Core Fintech Solutions & Impact</h2>
        </div>
        <div class="row align-items-center impact-main-content">
            <!-- Added Animation Trigger -->
            <div class="col-lg-6" [@fadeInUpStagger]="impactSectionVisible ? 'visible' : 'hidden'">
                <!-- Added animate-item class -->
                <p class="impact-description animate-item">
                    From crafting high-performance mobile wallets to building data-driven lending platforms and
                    regulatory technology automation systems, Kalpita provides end-to-end fintech software development
                    tailored to your business model. Examples of such solutions are: Digital Payments Platforms, Fraud
                    Detection & Risk Management Systems, Automated Compliance, AI-Powered Credit Assessment.
                </p>
                <p class="impact-description animate-item">
                    Our Microsoft-aligned engineering expertise ensures secure, compliant, and future-ready financial
                    systems that deliver measurable ROI.
                </p>
                <ul class="simple-impact-list animate-item">
                    <li>
                        50% faster report generation
                    </li>
                    <li>
                        30% improvement in data accuracy
                    </li>
                </ul>
            </div>
            <div class="col-lg-6">
                <div class="impact-image-wrapper">
                    <img src="../../../../assets/industries/fintech/fintechsolutions-img.png"
                        alt="Developer working on multiple screens">
                    <!-- Added Shine Effect -->
                    <div class="shine"></div>
                </div>
            </div>
        </div>
    </div>
</section>
<!-- Case Studies Section -->
<section class="case-studies-section">
    <div class="container">

        <div class="row justify-content-center text-center mb-5">
            <div class="col-lg-8">
                <h2 class="section-heading">Real Fintech Success Stories</h2>
                <!-- <p class="section-subheading">Real-world examples of our healthcare solutions in action.</p> -->
            </div>
        </div>

        <!-- Slider Wrapper -->
        <div class="case-study-slider-container" (mouseenter)="onMouseEnter()" (mouseleave)="onMouseLeave()">

            <!-- The Sliding Track -->
            <div class="slider-viewport">
                <div class="slider-track" [style.transform]="'translateX(-' + (currentSlide * 100) + '%)'"
                    [class.single-slide]="caseStudies.length === 1">

                    <!-- Loop through Case Studies -->
                    <div class="case-study-slide" *ngFor="let study of caseStudies">
                        <div class="row align-items-center">

                            <!-- Image Column (Left) -->
                            <div class="col-lg-5 d-flex justify-content-center">
                                <div class="case-study-image-wrapper">
                                    <img [src]="study.image" [alt]="study.title" class="img-fluid">
                                </div>
                            </div>

                            <!-- Content Column (Right) -->
                            <div class="col-lg-7">
                                <div class="case-study-content">
                                    <h3 class="case-study-title">{{ study.title }}</h3>
                                    <p class="case-study-description">
                                        {{ study.description }}
                                    </p>
                                </div>
                            </div>

                        </div>
                    </div>
                    <!-- End Loop -->

                </div>
            </div>

            <!-- Pagination Dots -->
            <div class="slider-dots" *ngIf="caseStudies.length > 1">
                <span *ngFor="let study of caseStudies; let i = index" class="dot" [class.active]="i === currentSlide"
                    (click)="goToSlide(i)">
                </span>
            </div>

        </div>
    </div>
</section>
<!-- Testimonial Section -->
<!-- <section class="written-testimonial-section custom-testimonial written-testimonial-wrapper">
  <h2 class="written-heading">Testimonials</h2>

  <app-clients-testimonal [hideHeading]="true"></app-clients-testimonal>
</section> -->
<div class="healthcare-section-bg">
    <section class="healthcare-section container py-5">
        <div class="glass-panel-container">
            <div class="row align-items-center">
                <div class="col-lg-6">
                    <h2 class="healthcare-heading mb-3">
                        What Our Clients Say
                    </h2>
                    <div class="mb-5 contact-btn">
                        <button class="btn hire-btn hire" (click)="testimonials()">
                            Read how global fintech leaders transform with Kalpita
                        </button>
                    </div>
                </div>

                <div class="col-lg-6 text-center">
                    <img src="../../../../assets/clientscta/clientsctaimage.webp" alt="Clients CTA"
                        class="img-fluid testimonial-hero-image">
                </div>
            </div>
        </div>
    </section>
</div>
<!-- FAQ -->
<app-faq [faqList]="FinanceFaqs"></app-faq>
<!-- Final CTA -->
<div class="final-cta-bg">
    <img src="../../../../assets/industries/healthcare/half-tablet.png" alt="Decorative capsule"
        class="cta-capsule-img">
    <section id="final-cta" class="final-cta-section container">
        <div class="section-header text-center mx-auto">
            <!-- <h2>Final CTA</h2> -->
        </div>
        <div class="row align-items-center">
            <div class="col-lg-6 cta-content-col">
                <h2 class="cta-heading-small">Let’s Build What’s Next in Fintech</h2>

                <div class="mb-5 cta-btn-group">
                    <!-- <button class="btn btn-get-started me-3" (click)="getStarted()">
            Get Started
          </button> -->
                    <button class="btn btn-schedule-demo" (click)="scheduleDemo()">
                        Schedule a Free Consultation
                    </button>
                </div>
            </div>
            <div class="col-lg-6 text-center">
                <img src="../../../../assets/industries/healthcare/health-pod-clinic.png" alt="Health POD Clinic"
                    class="img-fluid cta-clinic-image">
            </div>
        </div>
    </section>
</div>
<!-- Explore More Industries -->
<app-explore-more-industries></app-explore-more-industries>